export class DelegatedPermission {
    applicationName: string;
    applicationIcon: string;
    schoolName: string;
    permissionIndex: number;
    selectedPersonGuid: string;
    isDeleting: boolean;
    children: boolean; // should permissions be inherited by child organizations (if orgGuid = district.guid - all schools of a district)

    constructor(
        public applicationGuid: string = '',
        public personGuid: string = '',
        public personFriendlyName: string = '',
        public role: string = '',
        public orgGuid: string = '',
        public permissions: string[] = []
    ) {}
}

export enum PERMISSIONS_TO_DELEGATE {
    DELEGATE = 'Activate SSO for class',
    // ACTIVATE =  'Activate SSO',
    // CONFIGURE = 'Configure SSO'
}

// export const ALLOWED_DELEGATION_EDUTONE_TASKS = ['Staff', 'SchoolAdmin'];
export const ALLOWED_DELEGATION_EDUTONE_TASKS = ['Staff'];
export const ALLOWED_PERMISSIONS_TO_DELEGATE = ['DELEGATE'];

export const USER = 'User';
export const ROLE = 'Role';
export const USER_ENROLLMENT_SCHOOL = 'User enrollment school';

